import type { LanguageOption } from '@amzn/journeys-common';
import { faExternalLinkAlt, faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import { components } from 'react-select';
import { stylesheet } from 'typestyle';
import { TagSelect, type TagSelectProps } from './TagSelect';

export interface BullseyeMultiselectProps extends TagSelectProps {
  language: LanguageOption | null | undefined;
}

const css = stylesheet({
  link: {
    $nest: {
      '&:hover': {},
    },
    padding: '1px 10px 1px 5px',
  },
});

// biome-ignore lint/suspicious/noExplicitAny: legacy code
const MultiValueLabel = (props: any) => {
  const language = props.selectProps.language;
  const segmentId = props.data.value;

  const bullseyeUrl = language?.bullseyeUrl;
  const bullseyeLink = bullseyeUrl ? `${bullseyeUrl}/segment?id=${segmentId}` : '';

  return (
    <>
      <components.MultiValueLabel {...props} />
      {bullseyeLink && (
        <a
          className={css.link}
          data-cy="bullseye-tag-link"
          href={bullseyeLink}
          rel="noopener noreferrer"
          target="_blank"
          title={`Open segment ${segmentId} in Bullseye`}
        >
          <FontAwesomeIcon icon={faLink} />
        </a>
      )}
    </>
  );
};

export const BullseyeMultiselect: FC<BullseyeMultiselectProps> = ({ placeholder = 'Enter Bullseye segment ID(s)', ...props }) => {
  const bullseyeUrl = props.language?.bullseyeUrl;
  const bullseyeSegmentPageUrl = bullseyeUrl ? `${bullseyeUrl}/query?dst=both&usgCategory=OTHER` : '';

  return (
    <>
      <TagSelect
        components={{
          MultiValueLabel,
        }}
        formatCreateLabel={(inputValue) => `Segment ID: ${inputValue}`}
        isMulti
        isValidNewOption={(inputValue) => Number.isInteger(parseInt(inputValue, 10))}
        placeholder={placeholder}
        {...props}
      />
      {bullseyeSegmentPageUrl && (
        <a href={bullseyeSegmentPageUrl} rel="noopener noreferrer" target="_blank">
          <FontAwesomeIcon className="mr-2" icon={faExternalLinkAlt} />
          Create new segment
        </a>
      )}
    </>
  );
};
